/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Refresh_Presets_Button_Aria_LabelInputs */

const en_styles_refresh_presets_button_aria_label = /** @type {(inputs: Styles_Refresh_Presets_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh Presets`)
};

const fr_styles_refresh_presets_button_aria_label = /** @type {(inputs: Styles_Refresh_Presets_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualiser les presets`)
};

const de_styles_refresh_presets_button_aria_label = /** @type {(inputs: Styles_Refresh_Presets_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreinstellungen aktualisieren`)
};

const it_styles_refresh_presets_button_aria_label = /** @type {(inputs: Styles_Refresh_Presets_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna preimpostazioni`)
};

const ru_styles_refresh_presets_button_aria_label = /** @type {(inputs: Styles_Refresh_Presets_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительные настройки обновления`)
};

const es_styles_refresh_presets_button_aria_label = /** @type {(inputs: Styles_Refresh_Presets_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar ajustes preestablecidos`)
};

const zh_cn2_styles_refresh_presets_button_aria_label = /** @type {(inputs: Styles_Refresh_Presets_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刷新预设`)
};

const ja_styles_refresh_presets_button_aria_label = /** @type {(inputs: Styles_Refresh_Presets_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットを更新`)
};

const hi_styles_refresh_presets_button_aria_label = /** @type {(inputs: Styles_Refresh_Presets_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट रीफ़्रेश करें`)
};

const pt_pt2_styles_refresh_presets_button_aria_label = /** @type {(inputs: Styles_Refresh_Presets_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar predefinições`)
};

/**
* | output |
* | --- |
* | "Refresh Presets" |
*
* @param {Styles_Refresh_Presets_Button_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_refresh_presets_button_aria_label = /** @type {((inputs?: Styles_Refresh_Presets_Button_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Refresh_Presets_Button_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_refresh_presets_button_aria_label(inputs)
	if (locale === "de") return de_styles_refresh_presets_button_aria_label(inputs)
	if (locale === "it") return it_styles_refresh_presets_button_aria_label(inputs)
	if (locale === "ru") return ru_styles_refresh_presets_button_aria_label(inputs)
	if (locale === "es") return es_styles_refresh_presets_button_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_refresh_presets_button_aria_label(inputs)
	if (locale === "ja") return ja_styles_refresh_presets_button_aria_label(inputs)
	if (locale === "hi") return hi_styles_refresh_presets_button_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_refresh_presets_button_aria_label(inputs)
	return en_styles_refresh_presets_button_aria_label(inputs)
});